
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/smart-home-app",
      function () {
        return require("private-next-pages/success-stories/smart-home-app/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/smart-home-app"])
      });
    }
  